import { IconProps } from "../../utils/global-types/global-types";

const PlaygroundIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_2331_26744)">
        <g clipPath="url(#clip1_2331_26744)">
          <g clipPath="url(#clip2_2331_26744)">
            <path
              fill="currentColor"
              d="m15.305 13.79-4.232-7.055V2.83h.55a.549.549 0 1 0 0-1.097H6.133a.549.549 0 1 0 0 1.097h.549v3.905L2.45 13.79a1.098 1.098 0 0 0 .94 1.663h10.975c.845 0 1.373-.915.95-1.647l-.009-.015zm-6.18-2.943c-1.09-.552-2.13-.845-3.101-.879L7.702 7.17a.54.54 0 0 0 .079-.282V2.83h2.195v4.057c0 .1.027.197.078.282l2.622 4.373c-.82.161-1.994.092-3.55-.695"
            ></path>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2331_26744">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
        <clipPath id="clip1_2331_26744">
          <path fill="#fff" d="M.95 1.6h16v16h-16z"></path>
        </clipPath>
        <clipPath id="clip2_2331_26744">
          <path fill="#fff" d="M1.9 1.6h14v14h-14z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlaygroundIcon;
